import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import Storefront from "@/pages/Storefront";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product" element={<Storefront />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
